import { render, staticRenderFns } from "./supplierManage.vue?vue&type=template&id=9b52ecec&scoped=true&"
import script from "./supplierManage.vue?vue&type=script&lang=js&"
export * from "./supplierManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b52ecec",
  null
  
)

export default component.exports